module.exports = __webpack_public_path__ + "cape-verde.svg?1e8fe55ca1be4819d5a2c739231c3828";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/cape-verde.svg
// module id = 129
// module chunks = 10